import { DATASOURCE_NAME_MESSAGE, DATASOURCE_NAME_PATTERN } from "./datasource-create-actions";

/**
 * The datasource name field's FORMAT rule — required, then letters/digits/spaces — as one pure
 * function, so `ConnectorPickerModal`'s antd `Form.Item` and `ConnectorPickerPopover`'s plain
 * `KuikaInput` validate against exactly the same rule instead of two hand-written copies that can
 * drift apart.
 *
 * This is FORMAT only. Uniqueness — an existing datasource's name, or the AI/Blockly first-action
 * collision — needs the live `sd` and the picked type, and only matters at submit; that check
 * stays `validateNewDatasourceName` in `datasource-create-actions.ts`.
 *
 * Deliberately not trimmed: the modal's original antd rules were not trimmed either (`required`
 * only rejects an empty string, and the pattern itself allows spaces), so a name of pure spaces
 * has always been format-valid. Reproducing that quirk here keeps both surfaces identical instead
 * of "fixing" behaviour this change was not asked to touch.
 */
export const DATASOURCE_NAME_REQUIRED_MESSAGE: string = "Please enter a name";

export const getDatasourceNameFormatError = (name: string): string | undefined => {
  const value: string = name ?? "";
  if (value.length === 0) return DATASOURCE_NAME_REQUIRED_MESSAGE;
  if (!DATASOURCE_NAME_PATTERN.test(value)) return DATASOURCE_NAME_MESSAGE;
  return undefined;
};

export const isDatasourceNameFormatValid = (name: string): boolean => getDatasourceNameFormatError(name) === undefined;
